import {
  UPDATE_USER_INFO,
  UPDATE_USER_TOKEN,
} from '../constants/user';

export const updateUserInfo = (userInfo) => ({
  type: UPDATE_USER_INFO,
  userInfo,
});

export const updateUserToken = (userToken) => ({
  type: UPDATE_USER_TOKEN,
  userToken,
});
